import { Component, Input } from '@angular/core';
import { Menu } from '../../core/models/menu.model';
import { SideMenuService } from '../../core/services/side-menu/side-menu.service';

@Component({
  selector: 'app-side-bar-mobile',
  templateUrl: './side-bar-mobile.component.html',
  styleUrl: './side-bar-mobile.component.scss'
})
export class SideBarMobileComponent {

  @Input() public menuData: Menu[] = [];

  constructor(
    public sideMenuService: SideMenuService
  ) {}

  toggleSubmenu(doc: any) {
    doc.isOpen = !doc.isOpen;
  }


}
